import { createSelector, createSlice } from '@reduxjs/toolkit';
import { PaginationResponse } from 'src/models/PaginationResponse';

export interface UIState {
    loading: boolean;
    message: string;
    pagination: PaginationResponse;
}
export const initialState: UIState = {
    loading: false,
    message: undefined,
    pagination: {
        items: 0,
        pages: 0,
        last_page: 0,
        current_page: 1,
    },
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        showLoader: (state) => {
            state.loading = true;
        },
        hideLoader: (state) => {
            state.loading = false;
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
    },
});

// actions
export const { showLoader, hideLoader, setPagination } = uiSlice.actions;

// selectors
export const isLoading = createSelector(
    (state) => state.loading.loading || state.UI.loading,
    (loading) => loading
);

export default uiSlice.reducer;
